const features = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '极速追踪',
    desc: '7×24小时全天候监控全网热点，今日吃瓜事件第一时间送达，绝不错过任何一个大瓜。覆盖微博、抖音、小红书等20+主流平台。',
  },
  {
    id: 2,
    icon: 'ri-stack-line',
    title: '多维聚合',
    desc: '按话题、时间、热度多维度整理今日吃瓜热门大瓜，从话题标签到深度专题，提供全方位的内容消费体验。',
  },
  {
    id: 3,
    icon: 'ri-shield-check-line',
    title: '真实可靠',
    desc: '严格筛选信息来源，多方交叉验证事件真实性。吃瓜也要讲基本法，拒绝谣言和虚假信息，让每一口瓜都香甜可口。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            ✨ 为什么选择我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            今日吃瓜致力于为吃瓜群众打造最优质的热点追踪体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((feature, idx) => (
            <div
              key={feature.id}
              className="group p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-200 text-center"
            >
              <div className={`w-14 h-14 mx-auto rounded-2xl flex items-center justify-center mb-5 ${
                idx === 0 ? 'bg-primary-100 text-primary-600' :
                idx === 1 ? 'bg-accent-100 text-accent-700' :
                'bg-secondary-100 text-secondary-700'
              }`}>
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-heading text-foreground-800 mb-3 whitespace-nowrap">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}